'use client'

import React, { useCallback } from 'react'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/common/Select'

import { display12HourValue, setDateByType } from '@/helpers/date'
import type { Period } from '@/helpers/date'

export interface PeriodSelectorProps {
  period: Period
  date: Date | undefined
  setDate: (date: Date | undefined) => void
  onRightFocus?: () => void
  onLeftFocus?: () => void
}

export const TimePeriodSelect = React.forwardRef<
  HTMLButtonElement,
  PeriodSelectorProps
>(({ period, date, setDate, onLeftFocus, onRightFocus }, ref) => {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLButtonElement>) => {
      if (e.key === 'ArrowRight') onRightFocus?.()
      if (e.key === 'ArrowLeft') onLeftFocus?.()
    },
    [onRightFocus, onLeftFocus],
  )

  const handleValueChange = useCallback(
    (value: string) => {
      if (value !== 'AM' && value !== 'PM') {
        return
      }
      const tempDate = date ? new Date(date) : new Date()
      const hours = display12HourValue(tempDate.getHours())
      setDate(setDateByType(tempDate, hours.toString(), '12hours', value))
    },
    [date, setDate],
  )

  return (
    <div className="flex items-center">
      <Select value={period} onValueChange={handleValueChange}>
        <SelectTrigger
          ref={ref}
          className="w-full h-8"
          onKeyDown={handleKeyDown}
        >
          <SelectValue>{period}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="AM">AM</SelectItem>
          <SelectItem value="PM">PM</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
})

TimePeriodSelect.displayName = 'TimePeriodSelect'
